<template>
  <div class="card p-5">
    <!-- <p class="text-center font-size-small" v-html="$t('info_withdrawal')"></p> -->
    <div class="card-body">
      <div
        class="text-center"
        v-if="loader && available === null"
      >
        <Loader
          color="color2"
          size="big"
        />
      </div>
      <div v-else-if="available !== null">
        <!-- SELECT AMOUNT -->
        <div class="text-center">
          <h2 class="font-weight-bold font-size-regular mb-3 highlighted-color1">
            <span>{{ $t('choose_the_amount_to_withdraw') }}</span>
          </h2>
        </div>
        <div class="d-flex flex-column mb-2 align-items-center justify-content-center">
          <p class="font-size-small">{{ $t('minimum_withdrawal_amount') }}: <strong>R$ 5,00</strong></p>
          <div class="col-md-4 px-0 default-form">
            <Money
              class="form-control"
              v-model="$v.amount.$model"
              v-bind="money"
            />
          </div>
        </div> <!-- END SELECT AMOUNT -->
        <p class="font-size-small text-center mb-4" v-html="$t('info_payment_processor_transfer_fee', { attention: $t('attention'), amount: this.$options.filters.formatMoney(amount > 3.67 ? (amount - 3.67) : 0) })"></p>
        <!-- CONFIRM BANK ACCOUNT -->
        <div class="text-center">
          <h2 class="font-weight-bold font-size-regular mb-3 highlighted-color1">
            <span>{{ $t('receiving_account') }}</span>
          </h2>
        </div>
        <template
          v-if="account"
        >
          <p class="font-size-small text-center">
            <span class="d-block">{{ account.owner_name }}</span>
            <span class="d-block">{{ account.owner_document | VMask(documentMask) }}</span>
            <span class="d-block">{{ account.bank.name }}</span>
            <span class="d-block"><span class="text-color9 mb-1 fw-600">{{ $t('agency') }}:</span> {{ `${account.agency}${account.agency_digit ? '-' + account.agency_digit : ''}` }}</span>
            <span class="d-block"><span class="text-color9 mb-1 fw-600">{{ $t('account') }}:</span> {{ `${account.account}-${account.digit}` }}</span>
          </p>
          <p class="font-size-small text-center" v-html="$t('change_the_receiving_account', { attention: $t('attention') })"></p>
        </template>
        <template v-else>
          <p class="text-center font-size-small" v-html="$t('no_registered_bank_account_was_found')"></p>
        </template>
        <!-- END BANK ACCOUNT -->
        <div class="mt-4 text-center">
          <Button
            @click="submit"
            class="btn btn-color10"
            :loading="loader"
            :disabled="$v.$invalid || available <= 0 || $v.amount.$model < 5 || amount > (available / 100)"
          >
            {{ $t('request_withdrawal') }}
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import BankAccountsService from '@/modules/bank-accounts/services/bank-accounts-service'
import NotificationService from '@/modules/notifications/services/notifications-service'
import WalletsService from '@/modules/wallets/services/wallets-service'
import { mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { parseErrorResponseToArray } from '@/utils'
import { mask } from 'vue-the-mask'

import Button from '@/components/common/Button/Button'
import Loader from '@/components/common/Loader/Loader'
import { Money } from 'v-money'

export default {
  name: 'WalletCheckoutCreation',
  directives: { mask },
  components: {
    Button,
    Loader,
    Money
  },
  data () {
    return {
      amount: '',
      available: null,
      account: null,
      errors: null,
      loader: false,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      }
    }
  },
  validations () {
    return {
      amount: { required }
    }
  },
  created () {
    this.setWallet()
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    documentMask () {
      if (this.account.owner_document_type === 'cpf') return '###.###.###-##'
      return '##.###.###/####-##'
    }
  },
  methods: {
    /**
     * On modal hidden
    */
    hidden () {
      this.reset()
    },
    /**
     * Reset form
     */
    reset () {
      this.amount = ''
      this.available = null
      this.account = null
      this.errors = null
      this.loader = false
    },
    /**
     * On modal shown
     */
    async setWallet () {
      this.loader = true
      try {
        const account = await BankAccountsService.getPrimaryBankAccount({ companyId: this.user.company.id })
        this.account = account

        const amount = await WalletsService.getWalletAmounts({ companyId: this.user.company.id })
        this.available = amount.additional_info.amount_available_for_payment
      } catch (error) {
        console.log(error)
        this.errors = parseErrorResponseToArray(error)
      }
      this.loader = false
    },
    /**
     * Submit
     */
    async submit () {
      this.loader = true
      try {
        const wallet = await WalletsService.createCheckout({
          amount: (this.$v.amount.$model * 100).toFixed(0),
          companyId: this.user.company.id
        })
        this.$bvModal.hide('create-wallet-checkout-modal')
        const notification = {
          notification: {
            type: 'success',
            content: this.$t('withdrawal_request_created_successfully')
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
        this.$emit('wallet-checkout-created', wallet)
      } catch (error) {
        this.errors = parseErrorResponseToArray(error)
      }
      this.loader = false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
